module.exports = "/_next/static/images/1e49b3a7b4e105dd2394eb6497c24127-nuconta-inclined-device@2x.png";